import { SelectNetworkApiValues, VirtualMainState } from "@nerdjs/nerd-network";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { AppConfig } from "../../environement";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "",
  prepareHeaders(headers: Headers) {
    headers.append("Accept", "application/json");
    if (window._APP_CONFIG?.api?.authServerToken)
      headers.append(
        "auth-server-token",
        window._APP_CONFIG?.api?.authServerToken
      );
    return headers;
  },
  credentials: "include",
});

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  { service: string; overwriteApiVersion?: string }
> = async (args, api, extraOptions) => {
  const apiValues = SelectNetworkApiValues(api.getState() as VirtualMainState);
  const { overwriteApiVersion, service } = extraOptions;

  let url = apiValues.endpoint;
  if (overwriteApiVersion) {
    url += overwriteApiVersion;
  } else {
    url += apiValues.routePrefix;
  }

  if (service) {
    url += `/${service}/`;
  } else {
    url += "/";
  }

  let adjustedArgs: string | FetchArgs;
  if (typeof args === "string") {
    adjustedArgs = `${url}${args}`;
  } else {
    adjustedArgs = { ...args, url: `${url}${args.url}` };
  }

  const result = await rawBaseQuery(adjustedArgs, api, extraOptions);

  if (result.error && result.error.status === 401) {
    // debugger;
    window.location.replace(AppConfig.front["401Redirect"]);
    return result;
  }
  return result;
};
